import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { mockFAQs } from "../mock";

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 bg-red-600">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Frequently Asked 
            <span className="text-black"> Questions</span>
          </h2>
          <p className="text-white text-xl">
            Everything you need to know about training at Clara Boxing Academy
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {mockFAQs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`faq-${faq.id}`}
                className="bg-black border border-red-600/20 rounded-lg px-6"
              >
                <AccordionTrigger className="text-white hover:text-red-600 text-left text-lg font-semibold py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-16 bg-black text-white p-8 rounded-lg max-w-4xl mx-auto">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">Still Have Questions?</h3>
            <p className="text-red-100 text-lg mb-6">
              We're here to help! Don't hesitate to reach out with any questions 
              about our programs, pricing, or training philosophy.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-red-600 hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition-colors duration-300"
              >
                Contact Us
              </button>
              <a 
                href="tel:3128855934"
                className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-6 py-3 rounded-lg font-semibold transition-colors duration-300"
              >
                Call (312) 885-5934
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-black p-6 rounded-lg border border-red-600/20">
            <div className="text-red-600 text-3xl mb-4">💬</div>
            <h4 className="text-white font-bold text-lg mb-2">Quick Response</h4>
            <p className="text-gray-300">We respond to all inquiries within 24 hours</p>
          </div>
          
          <div className="bg-black p-6 rounded-lg border border-red-600/20">
            <div className="text-red-600 text-3xl mb-4">🏃‍♂️</div>
            <h4 className="text-white font-bold text-lg mb-2">Walk-ins Welcome</h4>
            <p className="text-gray-300">Stop by anytime to see the gym and meet the team</p>
          </div>
          
          <div className="bg-black p-6 rounded-lg border border-red-600/20">
            <div className="text-red-600 text-3xl mb-4">📅</div>
            <h4 className="text-white font-bold text-lg mb-2">Free Consultation</h4>
            <p className="text-gray-300">Schedule a free consultation to discuss your goals</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;